import { useState, useContext } from 'react';
import axios from 'axios';
import { 
  TextField, 
  Button, 
  Box, 
  Typography, 
  InputAdornment,
  Alert,
  Collapse,
  IconButton,
  Stack
} from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/Shield';
import LockIcon from '@mui/icons-material/Lock';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { UserContext } from './Context';

function AdminLogIn() {
  const { setUser } = useContext(UserContext);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [attemptsLeft, setAttemptsLeft] = useState(5);
  const [expanded, setExpanded] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/api/adminauth/login', { password });
      const { token } = response.data;
      
      // Stocker le token dans sessionStorage
      sessionStorage.setItem('authToken', token);
      sessionStorage.setItem('authExpiration', Date.now() + 4 * 60 * 60 * 1000); // 4 heures
      
      // Mettre à jour le contexte utilisateur
      setUser('admin');
    } catch (err) {
      if (err.response && err.response.status === 429) {
        setError('Trop de tentatives. Réessayez plus tard. <br/> Te veel pogingen. Probeer het later opnieuw.');
      } else if (err.response && err.response.status === 401) {
        setAttemptsLeft((prev) => prev - 1);
        setError(`Mot de passe incorrect. Tentatives restantes : ${attemptsLeft - 1} <br/> Onjuist wachtwoord. Resterende pogingen: ${attemptsLeft - 1}`);
      } else {
        setError('Erreur de connexion. <br/> Verbindingsfout.');
      }
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      <Box 
        onClick={() => setExpanded(!expanded)} 
        sx={{ 
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            fontWeight: 500
          }}
        >
          <AdminPanelSettingsIcon 
            fontSize="small" 
            sx={{ mr: 1, opacity: 0.7 }} 
          />
          Accès administrateur / Beheerders­toegang
        </Typography>
        <IconButton 
          size="small"
          sx={{ 
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s'
          }}
        >
          <ExpandMoreIcon fontSize="small" />
        </IconButton>
      </Box>
      
      <Collapse in={expanded}>
        <Box 
          component="form" 
          onSubmit={handleSubmit}
          sx={{
            mt: 2
          }}
        >
          <Stack 
            direction="row" 
            spacing={1}
            alignItems="center"
          >
            <TextField
              id="admin_password"
              name="admin_password"
              label="Mot de passe administrateur / Beheerderswachtwoord"
              type="password"
              size="small"
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon fontSize="small" color="action" />
                  </InputAdornment>
                ),
              }}
            />
            
            <IconButton
              type="submit"
              color="primary"
              size="small"
              aria-label="Connexion / Aanmelden"
              title="Connexion / Aanmelden"
            >
              <ArrowForwardIcon />
            </IconButton>
          </Stack>
          
          {error && (
            <Alert severity="error" sx={{ mt: 1, py: 0, whiteSpace: 'pre-line' }}>
              {error.replace(/<br\s*\/?>(\s*)/g, '\n')}
            </Alert>
          )}
        </Box>
      </Collapse>
    </Box>
  );
}

export default AdminLogIn;